'use strict';

var BannerCarouselConfig = require('../../../utils/bannerCarouselConfig');

$(document).ready(function () {
    $('.hero-banner-carousel-container').each(function () {
        var $carousel = $(this);
        var $slidesContainer = $carousel.find('.hero-banner-carousel-slides-region');
        var $prevArrow = $carousel.find('.hero-banner-carousel-arrow-prev');
        var $nextArrow = $carousel.find('.hero-banner-carousel-arrow-next');

        var isCarouselActive = $carousel.data('carousel-active') === true || $carousel.data('carousel-active') === 'true';
        var totalSlides = $slidesContainer.find('.hero-banner-carousel-slide').length;

        // If parent has no explicit height, use tallest child height
        if (!$carousel.hasClass('hero-banner-has-height')) {
            var maxDesktop = 0;
            var maxMobile = 0;

            $slidesContainer.find('.hero-slide-container').each(function () {
                var desktop = parseFloat($(this)[0].style.getPropertyValue('--hero-slide-height-desktop-svh'));
                var mobile = parseFloat($(this)[0].style.getPropertyValue('--hero-slide-height-mobile-svh'));

                if (desktop && desktop > maxDesktop) maxDesktop = desktop;
                if (mobile && mobile > maxMobile) maxMobile = mobile;
            });

            if (maxDesktop) $carousel[0].style.setProperty('--hero-banner-carousel-height-desktop-svh', maxDesktop + 'svh');
            if (maxMobile) $carousel[0].style.setProperty('--hero-banner-carousel-height-mobile-svh', maxMobile + 'svh');
        }

        if (!isCarouselActive || totalSlides <= 1) {
            return;
        }

        var autoRotate = $carousel.data('auto-rotate') === true || $carousel.data('auto-rotate') === 'true';
        var rotateInterval = (parseInt($carousel.data('rotate-interval'), 10) || 5) * 1000;
        var pauseOnHover = $carousel.data('pause-on-hover') === true || $carousel.data('pause-on-hover') === 'true';
        var showArrows = $carousel.data('show-arrows') === true || $carousel.data('show-arrows') === 'true';
        var showDots = $carousel.data('show-dots') === true || $carousel.data('show-dots') === 'true';

        var slickConfig = BannerCarouselConfig.getHeroBannerConfig({
            prevArrow: $prevArrow,
            nextArrow: $nextArrow,
            autoRotate: autoRotate,
            rotateInterval: rotateInterval,
            pauseOnHover: pauseOnHover,
            showArrows: showArrows,
            showDots: showDots
        });

        $slidesContainer.slick(slickConfig);

        if (showArrows) {
            BannerCarouselConfig.setupArrowHandlers($prevArrow, $nextArrow, $slidesContainer, 'hero-banner-carousel-slide');
        }

        BannerCarouselConfig.setupSwipeHandler($slidesContainer, 'hero-banner-carousel-slide');

        if (autoRotate) {
            BannerCarouselConfig.setupAutoRotateDetection($slidesContainer, $prevArrow, $nextArrow, 'hero-banner-carousel-slide');
            BannerCarouselConfig.setupVisibilityHandler($slidesContainer);
        }

        BannerCarouselConfig.setupKeyboardNavigation($carousel, $slidesContainer);
    });
});
